import { render, staticRenderFns } from "./ThreadUsers.vue?vue&type=template&id=4561e0ce&"
import script from "./ThreadUsers.vue?vue&type=script&lang=js&"
export * from "./ThreadUsers.vue?vue&type=script&lang=js&"
import style0 from "./ThreadUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports